import React, { useRef, useState, useEffect } from 'react';
import { ApiSearch } from '@assets/js/api/commonApi.js';
import CompFormVeCmptnDtl from '@components/form/comp-form-ve-cmptnDtl.js';
import CompFormVeCmptnApply from '@components/form/comp-form-ve-cmptnApply.js';
import '@assets/css/competition.css';

const Competition = (props) => {
    const [mngCdList, setMngCdList] = useState([]);
    const [selectedMngCd, setSelectedMngCd] = useState('');
    const [competitions, setCompetitions] = useState([]);

    const refCompFormVeCmptnDtl = useRef(null);
    const refCompFormVeCmptnApply = useRef(null);

    const isApplicationAvailable = (competition) => {
        if (!competition.formStrtDate || !competition.formDeadDate) {
            return false;
        }
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayString = `${yyyy}-${mm}-${dd}`;

        return todayString >= competition.formStrtDate && todayString <= competition.formDeadDate;
    }

    /*********************
     * Define events
    ***********************/
    // 전체 대회 리스트 조회
    const onSearchAll = () => {
        const searchParams = {
            useYn: 'Y'
        };

        ApiSearch('/ve/competition/search/list', searchParams).then(res => {
            if (res && res.success) {
                if (res.data.dataList) {
                    // 1.주최팀 리스트 설정
                    let mngCdList = [];
                    res.data.dataList.map(item => {
                        const mngList = mngCdList.filter(mng => mng.code === item.mngCd);
                        if (mngList.length === 0) {
                            mngCdList.push({code: item.mngCd, codeNm: item.hostOrgNm});
                        }
                    });
                    setMngCdList(mngCdList || []);
                    // 전체 탭을 기본으로 선택
                    setSelectedMngCd('ALL');

                    // 2.대회 리스트 설정
                    setCompetitions(res.data.dataList || []);
                }
            }
        });
    }

    // 대회 리스트 조회 (관리코드별)
    const onSearch = (mngCd) => {
        if (mngCd == null || mngCd === '') {
            return;
        }

        // 전체 탭인 경우
        if (mngCd === 'ALL') {
            onSearchAll();
            return;
        }

        const searchParams = {
            mngCd: mngCd,
            useYn: 'Y'
        };

        ApiSearch('/ve/competition/search/list', searchParams).then(res => {
            if (res && res.success) {
                if (res.data.dataList) {
                    setCompetitions(res.data.dataList || []);
                }
            }
        });
    }

    // 상세보기
    const onDetailClick = (competition) => {
        if (refCompFormVeCmptnDtl.current) {
            refCompFormVeCmptnDtl.current.modalToggle(competition);
        }
    }

    // 대회신청
    const onApplyClick = (competition) => {
        //대회신청 기간 체크.
        if (!isApplicationAvailable(competition)) {
            return;
        }

        if (refCompFormVeCmptnApply.current) {
            refCompFormVeCmptnApply.current.modalToggle(competition);
        }
    }

    // 탭 변경 (관리코드 탭)
    const handleTabChange = (mngCd) => {
        setSelectedMngCd(mngCd);
        onSearch(mngCd);
    }

    /**********************
     * Define useEffect
    ***********************/
    useEffect(() => {
        onSearchAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="competition-page-bg">
                <div className="container-fluid py-4">
                    {/* 헤더 */}
                    <div className="competition-header mb-4">
                        <h1 className="competition-title mb-0">대회 정보</h1>
                        <p className="text-muted mb-0 mt-2">팔씨름 대회를 확인하고 신청하세요</p>
                    </div>

                    {/* 탭 메뉴 - 관리코드 기반 */}
                    <ul className="nav nav-tabs mb-4 flex-wrap">
                        {/* 전체 탭 */}
                        <li className="nav-item">
                            <button
                                className={`nav-link ${selectedMngCd === 'ALL' ? 'active' : ''}`}
                                onClick={() => handleTabChange('ALL')}
                            >
                                <i className="bi bi-grid-3x3-gap me-2"></i>
                                전체
                            </button>
                        </li>

                        {/* 관리코드별 탭 */}
                        {mngCdList.map((mng, index) => (
                            <li key={index} className="nav-item">
                                <button
                                    className={`nav-link ${selectedMngCd === mng.code ? 'active' : ''}`}
                                    onClick={() => handleTabChange(mng.code)}
                                >
                                    <i className="bi bi-building me-2"></i>
                                    {mng.codeNm}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {/* 대회 목록 (박스 리스트) */}
                    <div className="competition-list-container">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                            {competitions.length === 0 ? (
                                <div className="col-12">
                                    <div className="alert alert-secondary text-center border-0 shadow-sm" role="alert">
                                        <i className="bi bi-info-circle me-2"></i>
                                        등록된 대회가 없습니다.
                                    </div>
                                </div>
                            ) : (
                        competitions.map((competition, index) => (
                            <div key={index} className="col">
                                <div className="card h-100 border-0 shadow-sm hover-lift" style={{ transition: 'all 0.3s ease' }}>
                                    {/* 헤더 - 대회 타입 배지 */}
                                    <div className="card-header border-0 card-header-gradient pt-4 pb-0">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <span className={`badge rounded-pill px-3 py-2 ${
                                                competition.comptnType === 'REGULAR' ? 'bg-primary' :
                                                competition.comptnType === 'SPECIAL' ? 'bg-danger' :
                                                'bg-success'
                                            }`} style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                                                {competition.comptnType === 'REGULAR' ? '🏆 ' : competition.comptnType === 'SPECIAL' ? '⭐ ' : '🤝 '}
                                                {competition.comptnTypeNm}
                                            </span>
                                            <div className="text-end">
                                                <small className="d-block" style={{ fontSize: '1rem', color: '#6c757d', fontWeight: '500' }}>
                                                    📅 <b>신청기간</b>
                                                </small>
                                                <small className="fw-bold d-block" style={{ fontSize: '0.95rem', color: '#212529', marginTop: '2px', minHeight: '1.5rem'}}>
                                                    {competition.formStrtDate === competition.formDeadDate ? '~ ' + (competition.formStrtDate == null ? '' : competition.formStrtDate) : competition.formStrtDate + ' ~ ' + competition.formDeadDate}
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 본문 */}
                                    <div className="card-body px-4 py-3">
                                        <h5 className="card-title mb-3 fw-bold" style={{
                                            color: '#212529',
                                            fontSize: '1.25rem',
                                            lineHeight: '1.4',
                                            minHeight: '2.8rem'
                                        }}>
                                            {competition.comptnNm}
                                        </h5>

                                        <div className="info-section">
                                            <div className="info-row mb-2">
                                                <span className="info-label">
                                                    <i className="bi bi-building me-2"></i>주최
                                                </span>
                                                <span className="info-value">
                                                    {competition.hostOrgNm || '-'}
                                                </span>
                                            </div>
                                            <div className="info-row mb-2">
                                                <span className="info-label">
                                                    <i className="bi bi-tag-fill me-2"></i>부문
                                                </span>
                                                <span className="info-value">
                                                    {competition.dvsnNm || '-'}
                                                </span>
                                            </div>
                                            <div className="info-row mb-2">
                                                <span className="info-label">
                                                    <i className="bi bi-speedometer2 me-2"></i>체급
                                                </span>
                                                <span className="info-value">
                                                    {competition.wetclsNm || '-'}
                                                </span>
                                            </div>
                                            <div className="info-row mb-2">
                                                <span className="info-label">
                                                    <i className="bi bi-person-badge me-2"></i>서포터
                                                </span>
                                                <span className="info-value">
                                                    {competition.supptsNm || '-'}
                                                </span>
                                            </div>
                                            <div className="info-row">
                                                <span className="info-label">
                                                    <i className="bi bi-calendar-check me-2"></i>대회일자
                                                </span>
                                                <span className="info-value">
                                                    {competition.strtDate === competition.endDate ? competition.strtDate : competition.strtDate + ' ~ ' + competition.endDate}
                                                </span>
                                            </div>
                                        </div>

                                        {/* 구분선 */}
                                        <hr className="competition-divider" />

                                        {/* 버튼 그룹 */}
                                        <div className="d-flex gap-2">
                                            <button
                                                className="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center flex-fill"
                                                onClick={() => onDetailClick(competition)}
                                                style={{
                                                    padding: '0.5rem 1rem',
                                                    fontWeight: '500',
                                                    borderWidth: '1.5px'
                                                }}
                                            >
                                                <i className="bi bi-eye me-2"></i>
                                                상세보기
                                            </button>
                                            <button
                                                className={`btn ${isApplicationAvailable(competition) ? 'btn-primary' : 'btn-secondary'} btn-sm d-flex align-items-center justify-content-center flex-fill`}
                                                onClick={() => onApplyClick(competition)}
                                                style={{
                                                    padding: '0.5rem 1rem',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                <i className="bi bi-pencil-square me-2"></i>
                                                대회 신청하기
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))
                        )}
                        </div>
                    </div>
                </div>
            </div>

            {/* 상세보기 폼 */}
            <CompFormVeCmptnDtl ref={refCompFormVeCmptnDtl} />

            {/* 대회신청 폼 */}
            <CompFormVeCmptnApply ref={refCompFormVeCmptnApply} />
        </>
    );
}
export default Competition;
